import { combineEpics } from 'redux-observable';

import accountEpic from './account';
import accountFavoritesEpic from './accountFavorites';
import addFavoriteEpic from './addFavorite';
import analyticsEpic from './analytics';
import browserSizingEpic from './browserSizing';
import coinProductsEpic from './coinProducts';
import deepLinksEpic from './deepLinks';
import favoritesEpic from './favorites';
import initEpic from './init';
import loginEpic from './login';
import logoutEpic from './logout';
import fastpanelEpic from './fastpanel';
import modalsTrackingEpic from './modals.tracking';
import notificationsEpic from './notifications';
import packageFavoritesRoute from './packageFavoritesRoute';
import packageRoute from './packageRoute';
import packagesEpic from './packages';
import removeFavoriteEpic from './removeFavorite';
import resetPasswordEpic from './resetPassword';
import routeEpic from './route';
import scrollPositionEpic from './scrollPosition';
import searchEpic from './search';
import signUpEpic from './signUp';
import singleCardEpic from './singleCard';
import singleCardRoute from './singleCardRoute';

// import cartEpic from './cart';
// import coinProductsEpic from './coinProducts';
// import currencyEpic from './currency';
// import deepLinksEpic from './deepLinks';
// import emailDesignEpic from './emailDesign';
// import eventDeliveryEpic from './eventDelivery';
// import eventEpic from './event';
// import experimentsEpic from './experiments';
// import experimentsTrackingEpic from './experiments.tracking';
// import localeEpic from './locale';

export default combineEpics(
  accountEpic,
  accountFavoritesEpic,
  addFavoriteEpic,
  analyticsEpic,
  browserSizingEpic,
  coinProductsEpic,
  deepLinksEpic,
  favoritesEpic,
  initEpic,
  loginEpic,
  logoutEpic,
  fastpanelEpic,
  modalsTrackingEpic,
  notificationsEpic,
  packageFavoritesRoute,
  packageRoute,
  packagesEpic,
  removeFavoriteEpic,
  resetPasswordEpic,
  routeEpic,
  scrollPositionEpic,
  searchEpic,
  signUpEpic,
  singleCardEpic,
  singleCardRoute,

  //   cartEpic,
  //   coinProductsEpic,
  //   currencyEpic,
  //   deepLinksEpic,
  //   emailDesignEpic,
  //   eventDeliveryEpic,
  //   eventEpic,
  //   experimentsEpic,
  //   experimentsTrackingEpic,
  //   localeEpic,
);
